import { isDemoPath } from "./demo/paths";
import { showStartupFailure } from "./startupFailure";

// Choose the trust boundary before App, api, monitoring, or saved sign-in
// modules are evaluated. Demo never imports the production startup module.
if (isDemoPath()) {
  import("./demo/start").then(({ startDemo }) => startDemo()).catch(showStartupFailure);
} else {
  import("./startApp").catch(showStartupFailure);
}
